import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/img/logo-hoai-thuong.png";
import AuthService from "../../services/authService";

// Route type
import { Route as RouteType } from "../../routes";

interface SidebarProps {
  routes: RouteType[];
  bgColor: string;
  activeColor: string;
}

const Sidebar: React.FC<SidebarProps> = ({
  routes,
  bgColor,
  activeColor
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeRoute, setActiveRoute] = useState("");

  useEffect(() => {
    setActiveRoute(location.pathname);
  }, [location]);

  // Verifies if routeName is the one active (in browser input)
  const isActiveRoute = (routeName: string): boolean => {
    return activeRoute.indexOf(routeName) > -1;
  };

  // Debug function to check user info
  const debugUserInfo = () => {
    const user = AuthService.getCurrentUser();
    console.log('User Info:', user);
    return user;
  };

  // Xử lý click vào logo
  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const user = debugUserInfo();
    
    // Đảm bảo người dùng tồn tại và có vai trò
    if (user && user.role) {
      // Xác định prefix dựa trên vai trò
      const prefix = user.role === 'staff' ? '/staff' : '/admin';
      
      // Đường dẫn đích là orders
      const targetPath = `${prefix}/orders`;
      
      console.log('Điều hướng đến:', targetPath, 'với vai trò:', user.role);
      navigate(targetPath);
    } else {
      // Nếu không có người dùng, chuyển đến trang đăng nhập
      console.log('Không có người dùng, chuyển đến trang đăng nhập');
      navigate('/auth/login');
    }
  };

  return (
    <div
      className="sidebar shadow"
      data-color={bgColor}
      data-active-color={activeColor}
    >
      <div className="logo text-center p-3 d-flex align-items-center justify-content-center">
        <a
          href="#"
          className="d-flex align-items-center"
          onClick={handleLogoClick}
          style={{ textDecoration: 'none' }}
        >
          <div className="logo-img mr-2">
            <img src={logo} alt="Hoài Thương Fruits" className="img-fluid" />
          </div>
          <span className="simple-text logo-normal font-weight-bold d-none d-md-inline">
            Hoài Thương Fruits
          </span>
        </a>
      </div>
      <div className="sidebar-wrapper d-none d-lg-block">
        <ul className="nav flex-column">
          {routes.map((prop, key) => {
            if (prop.hidden) return null;
            return (
              <li
                className={`nav-item mb-2 ${isActiveRoute(prop.layout + prop.path) ? "active" : ""}`}
                key={key}
              >
                <NavLink
                  to={prop.layout + prop.path}
                  className={({ isActive }) => 
                    `nav-link d-flex align-items-center py-3 ${isActive ? "active" : ""}`
                  }
                >
                  <div className="icon-container mr-3 text-center ">
                    <i className={prop.icon}></i>
                  </div>
                  <p className="m-0 font-weight-normal font-weight-bold" style={{ fontSize: '16px' }}> {prop.name}</p>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar; 